export const FETCH_MERCHANTS = 'fetchMerchants';
export const FETCHED_MERCHANTS = 'fetchedMerchants';
export const MERCHANT_VENUES_UPDATED = 'merchantVenuesUpdated';

export const FETCH_MERCHANT_VENUES = 'fetchMerchantVenues'
export const FETCHED_MERCHANT_VENUES = 'fetchedMerchantVenues'
